import ResponsiveInputWrapper from '../Utilities/ResponsiveInputWrapper';
import { DEFAULT_STRIPE_SUPPORTED_COUNTRIES } from '../../constants/Countries';
import { usePaymentFormContext } from '../../context/PaymentFormContext';
import PostalCodeInput from './PostalCodeInput';
import CountryInput from './CountryInput';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BasicAddress = ({
  postalCode,
  country,
  onChange
}) => {
  const {
    formState
  } = usePaymentFormContext();
  const disabled = formState.get('isCheckoutSubmitPending');
  return /*#__PURE__*/_jsxs(ResponsiveInputWrapper, {
    children: [/*#__PURE__*/_jsx(CountryInput, {
      validCountries: DEFAULT_STRIPE_SUPPORTED_COUNTRIES,
      value: country,
      onChange: event => onChange('country', event),
      disabled: disabled
    }), /*#__PURE__*/_jsx(PostalCodeInput, {
      value: postalCode,
      onChange: event => onChange('postalCode', event),
      disabled: disabled
    })]
  });
};
export default BasicAddress;